import Home from "./Home";
import LoginPageBuilder from "../LoginPageBuilder";

const routes = [
  {
    key: "ghl-theme",
    title: "GHL Theme",
    icon: "solar:palette-outline",
    route: "/",
    component: <Home />,
  },
  {
    key: "login-page-builder",
    title: "Login Page Builder",
    icon: "solar:login-3-outline",
    route: "/login-page-builder",
    component: <LoginPageBuilder />,
  },
];

export default routes;
